import { Group, Person } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { ExerciseType as IExerciseType } from '../types';

export interface ExerciseTypeProps {
  type: IExerciseType;
}

const ExerciseType = ({ type }: ExerciseTypeProps) => {
  const TypeIcon = type === IExerciseType.Classroom ? Group : Person;
  const label = type === IExerciseType.Classroom ? 'Team' : 'Individual';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <TypeIcon sx={{ color: 'text.secondary' }} />
      <Typography variant="overline" flex={{ xs: 1, sm: 0 }} whiteSpace="nowrap">
        {label}
      </Typography>
    </Box>
  );
};

export default ExerciseType;
